var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecklistIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "15px",
    viewBox: "0 0 17 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/icon/checklist") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Log-Entry",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-526.000000, -398.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(78.000000, 153.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(448.000000, 244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/checklist",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.647619, 0.640000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.87,
    fill: "#000000",
    x: 5.82857143,
    y: 1.28,
    width: 9.71428571,
    height: 1
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 0.64,
    points: "0 1.35414158 1.4880166 2.8246521 4.34629551 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.647619, 5.760000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fillOpacity: 0.87,
    fill: "#000000",
    x: 5.82857143,
    y: 1.28,
    width: 9.71428571,
    height: 1
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2-Copy",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 0.64,
    points: "0 1.35414158 1.4880166 2.8246521 4.34629551 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.647619, 10.880000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fillOpacity: 0.87,
    fill: "#000000",
    x: 5.82857143,
    y: 1.28,
    width: 9.71428571,
    height: 1
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2-Copy-2",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 0.64,
    points: "0 1.35414158 1.4880166 2.8246521 4.34629551 0"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistIcon);
export default __webpack_public_path__ + "static/media/checklist_icon.d00ce600a8edfd852e0d6d2b3b53e58e.svg";
export { ForwardRef as ReactComponent };